module.exports = __webpack_public_path__ + "static/img/kjdy_drdc.c2870f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjdy_drdc.jpeg
// module id = 1230
// module chunks = 0